import { Button } from '@mui/material';
import { Formik } from 'formik';

import { FieldInput } from 'src/components';
import { Flex } from 'src/components/Flex';
import { ResendFormToBillingContactValidation } from 'src/validation/SalesInvoice/ResendSalesInvoice.validation';

type ResendToBillingContactFormProps = {
    readonly onSubmit: (sender, billingContactEmailAddress, coverMessage) => void;
    readonly billingContactEmailAddress: string;
};

export default function ResendToBillingContactForm({
    onSubmit,
    billingContactEmailAddress,
}: ResendToBillingContactFormProps) {
    return (
        <Formik
            initialValues={{
                sender: process.env.APP_EMAIL_ACCOUNTS,
                billingContactEmailAddress,
                coverMessage: '',
            }}
            onSubmit={({ sender, billingContactEmailAddress, coverMessage }) => {
                onSubmit(sender, billingContactEmailAddress, coverMessage);
            }}
            validationSchema={ResendFormToBillingContactValidation}
        >
            {({ handleSubmit }) => {
                return (
                    <Flex gap="16px" flexDirection="column" padding="16px 8px">
                        <FieldInput
                            name="billingContactEmailAddress"
                            label="Billing Contact Email"
                            placeholder="Billing Contact Email"
                        />
                        <FieldInput name="sender" label="Sender" disabled />
                        <FieldInput
                            name="coverMessage"
                            label="Cover Message"
                            placeholder="Cover Message"
                        />
                        <Button
                            onClick={() => {
                                return handleSubmit();
                            }}
                            variant="main"
                        >
                            Resend
                        </Button>
                    </Flex>
                );
            }}
        </Formik>
    );
}
